// extracted by mini-css-extract-plugin
export default {"media":"MediaObject_media_jUJTc","imgSquare":"MediaObject_imgSquare_X078k"};